import axios from "axios";

const buscarStockProductoServicio = async (id) => {
    const token = localStorage.getItem("token");
    const config = {
        headers:{
            Authorization: token
        }
    };
    try {
        const respuesta = await axios.get(
            `${process.env.REACT_APP_API_URL}/productos/stock/${id}`,
            config
        );
        return [true, respuesta.data, respuesta.status];
    } catch (error) {
        return [false, null, error.status];
    }
}

const editarStockProductoServicio = async (id, data) => {
    const token = localStorage.getItem("token");
    const config = {
        headers:{
            Authorization: token
        }
    };
    try {
        const respuesta = await axios.put(
            `${process.env.REACT_APP_API_URL}/productos/stock/editar/${id}`,
            data,
            config
        );
        return [true, respuesta.data, respuesta.status];
    } catch (error) {
        return [false, null, error.status];
    }
}

export {
    buscarStockProductoServicio,
    editarStockProductoServicio
}